var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9066 0.688632C14.7174 -0.489238 11.8144 -0.132308 10.0059 1.50957C8.17371 -0.132308 5.28257 -0.47734 3.0934 0.688632C1.18977 1.69994 0 3.62736 0 5.73325C0 6.34003 0.0951814 6.93491 0.273647 7.44651C1.20167 11.4798 7.1981 16.7981 10.0059 16.7981C12.8019 16.7981 18.7864 11.4798 19.7026 7.5179C19.9048 6.93491 20 6.34003 20 5.73325C20 3.62736 18.8102 1.69994 16.9066 0.688632ZM18.3462 7.12528C17.4777 10.8849 11.8263 15.3704 10.0059 15.3704C7.98334 15.3704 2.47472 10.6589 1.64188 7.05389C1.48721 6.61368 1.41582 6.17346 1.41582 5.72135C1.41582 4.15086 2.30815 2.68744 3.74777 1.92599C4.41404 1.56906 5.18739 1.3787 5.94884 1.3787C7.30518 1.3787 8.59012 1.94979 9.45866 2.96109L9.99405 3.57977L10.5294 2.96109C11.8977 1.40249 14.3962 0.950381 16.2522 1.93789C17.6919 2.69934 18.5842 4.16276 18.5842 5.73325C18.5842 6.18536 18.5128 6.62557 18.3462 7.12528Z",
    fill: "#546587"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.312ad25a6fd6e10893b5b3dc52cebf2c.svg";
export { ForwardRef as ReactComponent };